const formatMask = (value, pattern) => {
  let i = 0, v = value.toString()
  return pattern.replace(/#/g, _ => v[i++]).replace(/undefined/g, '')
}

const trimTimeFromDate = (value, seperator) => {
  let d = value.trim().split(seperator)
  if (d.length > 1) {
    return d[0]
  }
  return value
}

export {
  formatMask,
  trimTimeFromDate
}
